import { AppName } from '../types/app-name.ts';

export const DEFAULT_APP = AppName.READING_CRITTERS;
